import BaseEffectAction from './BaseEffectAction.js';
import {initializeEffect} from 'components/effects/constants.js';

class AddEffectAction extends BaseEffectAction {
    constructor(sequencerEngine) {
        super(sequencerEngine);
    }

    execute({effect, track, group, send}) {
        let element = track || group || send;
        if (effect.isMidiEffect()) {
            element.midiEffects.addEffect(effect);
        } else {
            element.effectsChain.addEffect(effect);
        }

        /*
        if (track) {
            if (track.instrumentRack) {
                track = track.instrumentRack;
            }
            track.updateSteps();
        }
        */
    }
}

export default AddEffectAction;
